// frontend/src/reducers/adminReducers.js
import {
  ADMIN_DATA_REQUEST,
  ADMIN_DATA_SUCCESS,
  ADMIN_DATA_FAIL,
} from "../constants/adminConstants";

export const adminDataReducer = (
  state = { developersProjects: [] },
  action
) => {
  switch (action.type) {
    case ADMIN_DATA_REQUEST:
      return { loading: true, developersProjects: [] };
    case ADMIN_DATA_SUCCESS:
      return { loading: false, developersProjects: action.payload };
    case ADMIN_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
